<template>
  <div
    ref="root"
    class="relative select-none overflow-hidden touch-none cursor-ew-resize"
    @pointerdown="onPointerDown"
    @pointermove="onPointerMove"
    @pointerup="onPointerUp"
    @pointercancel="onPointerUp"
  >
    <!-- Unteres Bild (nachher) -->
    <img
      :src="afterSrc"
      :alt="afterAlt"
      class="block w-full"
      draggable="false"
      @load="measure"
    />
    <span
      v-if="afterLabel"
      class="pointer-events-none absolute top-2.5 right-2.5 z-10 rounded bg-white/70 px-2 py-1 text-sm text-default"
    >{{ afterLabel }}</span>

    <!-- Oberes Bild (vorher), über inline width geclippt -->
    <div
      class="pointer-events-none absolute inset-y-0 left-0 z-20 overflow-hidden will-change-[width]"
      :style="{ width: position + '%' }"
    >
      <img
        :src="beforeSrc"
        :alt="beforeAlt"
        class="block h-full max-w-none"
        :style="{ width: rootWidth ? rootWidth + 'px' : '100vw' }"
        draggable="false"
      />
      <span
        v-if="beforeLabel"
        class="pointer-events-none absolute top-2.5 left-2.5 rounded bg-white/70 px-2 py-1 text-sm text-default"
      >{{ beforeLabel }}</span>
    </div>

    <!-- Trennlinie + Griff -->
    <div
      class="absolute inset-y-0 z-30 w-px -translate-x-1/2 bg-white"
      :style="{ left: position + '%' }"
      aria-hidden="true"
    ></div>
    <button
      type="button"
      class="absolute top-1/2 z-40 flex h-12 w-12 -translate-x-1/2 -translate-y-1/2 cursor-ew-resize items-center justify-center rounded-full border-[3px] border-white bg-accent-1/50 text-white shadow-[0_0_12px_rgba(51,51,51,0.5)] focus:outline-none focus-visible:ring-2 focus-visible:ring-white"
      :style="{ left: position + '%' }"
      :aria-valuenow="Math.round(position)"
      aria-valuemin="0"
      aria-valuemax="100"
      role="slider"
      :aria-label="beforeLabel && afterLabel ? beforeLabel + ' / ' + afterLabel : 'Bildvergleich'"
      @keydown="onKeydown"
    >
      <svg class="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7l-5 5 5 5M16 7l5 5-5 5" />
      </svg>
    </button>
  </div>
</template>

<script>
// Ersatz für das jQuery-Plugin imagesCompare: zwei übereinandergelegte
// Bilder, das obere wird per Pointer-Drag über die inline width des
// Clip-Containers freigestellt.
export default {
  name: 'BeforeAfter',
  props: {
    beforeSrc: { type: String, required: true },
    afterSrc: { type: String, required: true },
    beforeLabel: { type: String, default: '' },
    afterLabel: { type: String, default: '' },
    beforeAlt: { type: String, default: '' },
    afterAlt: { type: String, default: '' },
  },
  data() {
    return {
      position: 50, // Prozent der sichtbaren "Vorher"-Fläche
      rootWidth: 0,
      dragging: false,
      resizeObserver: null,
    }
  },
  mounted() {
    this.measure()
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => this.measure())
      this.resizeObserver.observe(this.$refs.root)
    } else {
      window.addEventListener('resize', this.measure)
    }
  },
  beforeUnmount() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    } else {
      window.removeEventListener('resize', this.measure)
    }
  },
  methods: {
    measure() {
      if (this.$refs.root) {
        this.rootWidth = this.$refs.root.getBoundingClientRect().width
      }
    },
    setFromClientX(clientX) {
      const rect = this.$refs.root.getBoundingClientRect()
      if (!rect.width) return
      const ratio = (clientX - rect.left) / rect.width
      this.position = Math.min(100, Math.max(0, ratio * 100))
    },
    onPointerDown(event) {
      this.dragging = true
      this.$refs.root.setPointerCapture(event.pointerId)
      this.setFromClientX(event.clientX)
    },
    onPointerMove(event) {
      if (!this.dragging) return
      this.setFromClientX(event.clientX)
    },
    onPointerUp(event) {
      if (!this.dragging) return
      this.dragging = false
      if (this.$refs.root.hasPointerCapture(event.pointerId)) {
        this.$refs.root.releasePointerCapture(event.pointerId)
      }
    },
    onKeydown(event) {
      if (event.key === 'ArrowLeft') {
        this.position = Math.max(0, this.position - 5)
        event.preventDefault()
      } else if (event.key === 'ArrowRight') {
        this.position = Math.min(100, this.position + 5)
        event.preventDefault()
      }
    },
  },
}
</script>
